import { removeGQLTypename } from "../helpers/index";
export default {
  data() {
    return {
      editedItem: {},
      showEditDialog: false,
    };
  },

  computed: {
    items() {
      const gqlList = this[this.GQLtypeName];
      return gqlList ? gqlList.edges.map(removeGQLTypename) : [];
    },
  },

  methods: {
    onCreateItem() {
      this.editedItem = {};
      this.showEditDialog = true;
    },
    onEditItem(item) {
      this.editedItem = { ...item };
      this.showEditDialog = true;
    },
    async onSave(payload) {
      this.showEditDialog = false;
      const { id, ...input } = payload;
      const mutation = payload.id ? this.updateMutation : this.createMutation;
      try {
        const mutationRes = await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: { ...input }, id },
          refetchQueries: [
            {
              query: this.listQuery,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: this.modelLabel + "  Saved.",
        });
      } catch (error) {
        console.log(error);
      }
    },
    async onDeleteItem(payload) {
      try {
        await this.$apollo.mutate({
          mutation: this.deleteMutation,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: this.listQuery,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: this.modelLabel + " deleted",
        });
      } catch (error) {
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/BasicCRUD.js